<template>
  <!-- 首页Banner轮播组件 -->
  <div class="home-banner-container">
    <el-carousel :interval="carouselConfig.interval" :arrow="carouselConfig.arrow" :height="carouselConfig.height"
      :autoplay="carouselConfig.autoplay" :loop="carouselConfig.loop">
      <el-carousel-item v-for="(item, index) in carouselItems" :key="`carousel-item-${index}`">
        <div @click="handleCarouselClick(item)" class="banner-background jc-center flex-column e-flex"
          :style="getBannerBackgroundStyle(item.imageKey)" :title="item.title || '点击查看详情'">
          <slot :name="`banner-slot-${index}`" :item="item"></slot>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { mapGetters, CONFIG_GETTERS } from '@/store/modules/config'
import { isLogin, showLogin } from '@/shared/user'
import VipJumpUtil from '@/util/vipJumpUtil';


export default {
  name: 'HomeBanner',
  data() {
    return {
      carouselConfig: {
        interval: 5000,
        arrow: 'always',
        height: '560px',
        autoplay: true,
        loop: true
      },
      carouselItems: [
        {
          imageKey: 7,
          actionType: 'link',
          title: '点击立即试用'
        },
        {
          imageKey: 1,
          actionType: 'login',
          title: '点击注册登录'
        },
        {
          imageKey: 2,
          actionType: 'route',
          routePath: '/applicationPerformance',
          title: '前往申请履约保函页面'
        },
        {
          imageKey: 3,
          actionType: 'route',
          routePath: '/guaranteeBankView',
          title: '前往申请电子担保保函页面'
        },

      ]
    }
  },
  computed: {
    ...mapGetters({
      isZCMOrigin: CONFIG_GETTERS.IS_ZCM_ORIGIN
    }),
    images() {
      const prefix = '/static/banners'
      return this.carouselItems.map(item => {
        return this.isZCMOrigin
          ? `${prefix}/banner-zcm-${item.imageKey}.jpg`
          : `${prefix}/banner-${item.imageKey}.jpg`
      })
    },
    isHlj() {
      return this.$store.state.letter.isHlj
    },
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    }
  },
  created() {
    if (this.isHlj) {
      this.carouselItems = this.carouselItems.filter(item => item.imageKey !== 7)
    }
    if (this.isBsgzw) {
      this.carouselItems = this.carouselItems.filter(item => item.imageKey !== 7 && item.imageKey !== 1)
    }
  },
  methods: {
    handleCarouselClick(item) {
      switch (item.actionType) {
        case 'login':
          this.handleShowLogin()
          break
        case 'route':
          if (this.$store.state.letter.isCqsw) {
            return
          }
          this.handleRouteJump(item.routePath)
          break
        case 'link':
          this.handleOpenLink(item)
          break
        default:
          console.warn(`未知的行为类型：${item.actionType}`)
      }
    },
    handleShowLogin() {
      if (!isLogin()) {
        showLogin()
      } else {
        this.$message.info('您已登录，无需重新登录')
      }
    },
    handleRouteJump(path) {
      if (path) {
        this.$router.push(path)
      } else {
        console.warn('路由地址不能为空')
      }
    },

    handleOpenLink(item) {
      if (item.url) {
        window.open(url, '_blank')
      } else {
        if (item.imageKey === 7) {
          VipJumpUtil.jumpToVip(this)
        }
      }
    },

    getBannerBackgroundStyle(imageKey) {
      const imageIndex = this.carouselItems.findIndex(item => item.imageKey === imageKey)
      //
      const backgroundImage = this.images[imageIndex]
        ? `url(${this.images[imageIndex]})`
        : 'url(/static/banners/banner-default.jpg)'

      return {
        backgroundImage,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover'
      }
    }
  }
}
</script>

<style scoped>
.banner-background {
  height: 100%;
  cursor: pointer;
}
</style>
